<!--
 * @Description: 试卷单条查找带回
 * @Author: PF
 * @Date: 2023-09-11 10:03:57
 * @LastEditors: PF
 * @LastEditTime: 2024-10-17 14:10:15
-->
<template>
  <div class="tan-chuang">
    <el-dialog style="min-width: 770px;" class="wp70 hp70" :model-value="openDanTiao" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <span class="header-title">试卷</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDanTiao', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-container>
        <el-header class="mb10 pl0 pr0">
          <!-- 搜索区域 BEGIN -->
          <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>
            <el-form-item>
              <el-input placeholder="试卷名称" v-model="dataGrid.parms.sjmc" clearable @clear="bindTable()" @keyup.enter="bindTable()">
                <template #suffix>
                  <el-icon class="el-input__icon pointer" @click="bindTable()">
                    <search />
                  </el-icon>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-select v-model="dataGrid.parms.zjfs" placeholder="组卷方式" clearable filterable @change="bindTable()">
                <el-option v-for="item in zjfsData.list" :key="item.value" :label="item.name" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item></el-form-item>
          </el-form>
          <!-- 搜索区域 END -->
        </el-header>
        <el-main class="mb10 pl0 pr0">
          <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
            <!-- 冻结列-Left BEGIN -->
            <el-table-column label="序号" type="index" fixed align="center" width="80" />
            <el-table-column label="试卷名称" prop="sjmc" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
              <template #default="scope">
                <span style="color: #409EFF;cursor: pointer;" @click="openDetail=true; row=scope.row">{{scope.row.sjmc}}</span>
              </template>
            </el-table-column>
            <!-- 冻结列-Left END -->
            <el-table-column label="建议考试时长(分)" prop="jykssc" align="center" show-overflow-tooltip />
            <el-table-column label="满分分数" prop="mffs" align="center" show-overflow-tooltip />
            <el-table-column label="及格分数" prop="jgfs" align="center" show-overflow-tooltip />
            <el-table-column label="组卷方式" prop="zjfs" align="center" show-overflow-tooltip>
              <template #default="scope">
                {{ scope.row.zjfs.name }}
              </template>
            </el-table-column>
            <!-- 冻结列-Right BEGIN -->
            <el-table-column label="操作" width="90" fixed="right" align="center">
              <template #default="scope">
                <el-button type="primary" @click="savestudent(currentRow=scope.row)">选择</el-button>
              </template>
            </el-table-column>
            <!-- 冻结列-Right END -->
          </el-table>
        </el-main>
      </el-container>
      <template #footer>
        <div class="dialog-footer">
        <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
          <div class="footer-but">
            <el-button type="info" @click="closeWindow('openDanTiao', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
    <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" />
  </div>
</template>
<script setup>
import { ref, defineProps, watch, defineEmits } from 'vue'
import { closeWindow, loadList, loadSelect } from '@/api/common'
import pagination from '@/components/pagination.vue'
import detail from '@/pages/shuzijiaoxue/ziyuanku/shijuan/detail.vue'

const props = defineProps({
  openDanTiao: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDanTiao', 'ReturnData'])
const row = ref()
const currentRow = ref()

const savestudent = () => {
  emits('ReturnData', currentRow.value)
  closeWindow('openDanTiao', emits, false)
}
// 试卷审核状态
const shztData = ref({ list: [] })
// 组卷方式
const zjfsData = ref({ list: [] })

// 列表
const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {
    pagerCount: 5,
    layout: 'prev, pager, next, total'
  },
  loading: false,
  orderBy: { prop: 'sjmc', order: 'ascending' }, // ['ascending', 'descending']
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  dataGrid.value.parms.shzt = shztData.value.shenHeTongGuo
  loadList({
    url: '/api/v2/ziyuanku/shijuan/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    pagerCount: 5,
    layout: 'prev, pager, next, total',
    dataGrid: dataGrid.value,
    loadSuccess: function () {
      dataGrid.value.multipleSelection = []
    }
  })
}
watch(
  () => props.openDanTiao,
  () => {
    if (props.openDanTiao) {
      row.value = props.row
      loadSelect({ url: '/api/v2/ziyuanku/shijuan/zujuanfangshi', data: zjfsData })
      loadSelect({ url: '/api/v2/ziyuanku/shijuan/shijuanshenhezhuangtai', data: shztData, loadSuccess: function () { bindTable() } })
    }
  },
  { deep: true, immediate: true }
)
const openDetail = ref(false)
</script>

<style lang="less" scoped>
</style>
